<div class="ui-g p-0 ro-partstech-container">
  <div class="ui-g-12 p-0 ro-partstech">
    <!-----------START------------------------NEXPART Quotes Section-----------------------START-------------------->
    <div *ngFor="let qoute of _orders.nexpart; let ind = index" class="ui-g-12 p-0 ro-partstech-order flex-column" [hidden]="!isNexpartEnabled">
      <div class="partstech-order">
        <div class="partstech-order-header width-100p flex-between-center p-2" [ngClass]="{ 'disabled-estimate-field': isArchived }">
          <img src="assets/img/nextpart-integration.svg" class="partstech-logo pl-2" alt="PartsTech" />

          <div class="partstech-order-header-right flex-end-center">
            <div class="flex-column">
              <span class="mr-3 font-13"> Last synced: {{ qoute?.lastSyncAt }} </span>
            </div>
            <div [ngClass]="{ 'disabled-estimate-btn': estimate?.isArchived }">
              <button
                class="btn font-600"
                [ngClass]="{ 'btn-secondary': qoute.isOrderPlaced, 'btn-primary': !qoute.isOrderPlaced }"
                [disabled]="isArchived || isPlacingOrder?.nexpart || isModifyingOrder?.nexpart || isOrderPlacing || qoute.isOrderPlaced || estimate?.isArchived"
                (click)="modifyNexpartQoute(qoute?.accountId, 'review')"
              >
                <span [ngClass]="{ 'pr-2': isPlacingOrder?.nexpart && !qoute.isOrderPlaced }">
                  {{ qoute?.isOrderDelivered ? 'Delivered' : qoute.isOrderPlaced ? 'Order Submitted' : 'Place order' }}
                </span>
                <i class="fal fa-spinner rotate" *ngIf="isPlacingOrder?.nexpart && !qoute.isOrderPlaced"></i>
              </button>
            </div>
          </div>
        </div>

        <div class="partstech-order-theader width-100p flex-start-center p-2 mb-1">
          <p class="m-0 font-600 name pl-2">Item name</p>
          <p class="m-0 font-600 description pl-2">Description</p>
          <p class="m-0 font-600 number pl-2">Item#</p>
          <p class="m-0 font-600 cost">Cost</p>
          <p class="m-0 font-600 list-price">
            List Price
            <i class="fal fa-info-circle text-dark pl-1" tooltipPosition="top" pTooltip="List price is the vendor's recommended price"></i>
          </p>
          <p class="m-0 font-600 core">Core</p>
          <p class="m-0 font-600 qty text-left">Qty</p>
          <p class="m-0 font-600 amount">Amount</p>
          <p class="m-0 font-600 service pl-2">Service</p>
          <p class="m-0 font-600 status text-right">Status</p>
          <p class="m-0 font-600 action pr-2"></p>
        </div>

        <div class="partstech-order-body width-100p flex-column p-2" *ngFor="let order of qoute.orders; let orderIndex = index">
          <p class="supplier-name m-0 font-gray-85 font-600 ml-2 mr-2 mb-1 pb-1">
            {{ order?.supplier?.name }}
            <span *ngIf="order?.supplier?.orderNo">&nbsp;({{ order?.supplier?.orderNo }})</span>
          </p>

          <div class="part-row flex-start-center" *ngFor="let part of order?.parts; let partIndex = index">
            <div class="m-0 name pl-2 flex-between-center not-allowed" tooltipPosition="top" [pTooltip]="part?.partName">
              <img *ngIf="part?.imageUrl" class="thumbnail pr-2" [src]="part?.imageUrl" [alt]="part?.partName" />
              <p class="part-name text-truncate m-0" [ngClass]="{ 'no-service-attached': !getPartService(part.orderItemId, part.partId), 'not-allowd': estimate?.isArchived }">
                <span [ngClass]="{ error: !getPartService(part.orderItemId, part.partId) }">{{ part?.partName }}</span>
              </p>
            </div>

            <p class="m-0 description text-truncate pl-2 not-allowed" [ngClass]="{ 'not-allowed': estimate?.isArchived }" tooltipPosition="top" [pTooltip]="part?.partName">
              <span>{{ part?.description || part?.partName }}</span>
            </p>

            <p class="m-0 number text-truncate pl-2 not-allowed" [ngClass]="{ 'not-allowed': estimate?.isArchived }">
              <span [pTooltip]="part?.partNumber">{{ part?.partNumber }}</span>
            </p>

            <p class="m-0 cost not-allowed" tooltipPosition="top" [pTooltip]="part?.costUpdateMessage" [ngClass]="{ 'font-red': part?.isCostUpdated }">
              {{ part?.price?.cost | currency : usd }}
            </p>

            <p class="m-0 list-price not-allowed" tooltipPosition="top" [pTooltip]="part?.priceUpdateMessage" [ngClass]="{ 'font-red': part?.isPriceUpdated }">
              {{ part?.price?.list | currency : usd }}
            </p>

            <p class="m-0 core not-allowed pr-0" [ngClass]="{ 'not-allowed': estimate?.isArchived }">
              {{ part?.price?.core | currency : usd }}
            </p>

            <p class="m-0 qty not-allowed" [ngClass]="{ 'not-allowed': estimate?.isArchived }">
              {{ part?.quantity | number : '1.2-2' }}
            </p>

            <p class="m-0 amount not-allowed" [ngClass]="{ 'not-allowed': estimate?.isArchived }">
              {{ part?.amount | currency : usd }}
            </p>

            <div class="m-0 service partstech-service-dropdown pl-2" [ngClass]="{ 'no-service-attached': !getPartService(part.orderItemId, part.partId) }">
              <div [ngClass]="{ 'disabled-estimate-field': estimate?.isArchived }">
                <app-dropdown
                  placeholder="Select service"
                  styleClassText="pr-3"
                  field="title"
                  theme="light"
                  scrollHeight="300px"
                  itemWidth="250px"
                  editFieldLabel="Unassign service"
                  [hasEditableField]="!!getPartService(part.orderItemId, part.partId)"
                  [disabled]="true"
                  [value]="getPartService(part.orderItemId, part.partId)"
                  [fontSize]="12"
                  [truncateString]="true"
                  [isDropdownIconVisible]="true"
                  [options]="services"
                  [isStaticEditButton]="true"
                >
                </app-dropdown>
              </div>
            </div>

            <p
              class="m-0 status pr-2 text-truncate not-allowed"
              tooltipPosition="top"
              [pTooltip]="_orders.nexpart[ind]?.isOrderDelivered ? 'Delivered' : qoute.isOrderPlaced && !part.deliveryStatus ? 'Ordered' : part?.status"
            >
              <span>{{ _orders.nexpart[ind]?.isOrderDelivered ? 'Delivered' : qoute.isOrderPlaced && !part.deliveryStatus ? 'Ordered' : part?.status }}</span>
            </p>
          </div>
        </div>
      </div>
    </div>
    <!-- Nexpart suppliers Footer for total amount values -->
    <div *ngIf="_totalSuppliers?.nexpart?.length && isNexpartEnabled" class="ui-g-12 p-0 partstech-supplier mb-4">
      <!-- Supplier table header -->
      <div class="partstech-supplier-header flex-column width-100p pt-2 pb-2">
        <div class="flex-start-center">
          <p class="m-0 font-600 name pl-2">Supplier</p>

          <p class="m-0 font-600 qty flex-center-center">
            <span class="width-90p">Quantity</span>
          </p>

          <p class="m-0 font-600 cost flex-center-center">
            <span class="width-100px">Items&nbsp;Total&nbsp;Cost</span>
          </p>

          <p class="m-0 font-600 ship-cost flex-center-center">
            <span class="width-90p">Shipping</span>
          </p>

          <p class="m-0 font-600 order-total pr-2 flex-center-center">
            <span class="width-90p">Order Total</span>
          </p>
        </div>
      </div>

      <!-- Supplier table body -->
      <div class="partstech-supplier-body width-100p flex-start-center pt-2 pb-2" *ngFor="let supplier of _totalSuppliers?.nexpart">
        <p class="m-0 name pl-2">
          {{ supplier?.name }}
        </p>

        <p class="m-0 qty flex-center-center">
          <span class="width-90p">{{ supplier?.quantity | number : '1.2-2' }}</span>
        </p>

        <p class="m-0 cost flex-center-center">
          <span class="width-100px">{{ supplier?.cost | currency : usd }}</span>
        </p>

        <p class="m-0 ship-cost flex-center-center">
          <span class="width-90p"> {{ supplier?.shippingPrice | currency : usd }}</span>
        </p>

        <p class="m-0 order-total pr-2 flex-center-center">
          <span class="width-90p">{{ supplier?.orderTotal | currency : usd }}</span>
        </p>
      </div>

      <!-- Supplier table footer -->
      <div class="partstech-supplier-footer width-100p flex-start-center pt-2 pb-2">
        <p class="m-0 font-600 name pl-2">Total</p>

        <p class="m-0 font-600 qty flex-center-center">
          <span class="width-90p">{{ _orderTotal?.nexpart?.quantity | number : '1.2-2' }}</span>
        </p>

        <p class="m-0 font-600 cost flex-center-center">
          <span class="width-100px">{{ _orderTotal?.nexpart?.cost | currency : usd }}</span>
        </p>

        <p class="m-0 font-600 ship-cost flex-center-center">
          <span class="width-90p">{{ _orderTotal?.nexpart?.shippingPrice | currency : usd }}</span>
        </p>

        <p class="m-0 font-600 order-total pr-2 flex-center-center">
          <span class="width-90p">{{ _orderTotal?.nexpart?.orderTotal | currency : usd }}</span>
        </p>
      </div>
    </div>
    <!-----------END------------------------NEXPART Quotes Section-----------------------END-------------------->

    <!-----------START------------------------PartsTech Quotes Section-----------------------START-------------------->
    <p *ngIf="orders?.length && isPartsTechEnabled" class="mb-2 pb-1 font-bold font-16 font-secondary-900 part-ordering-section-heading">PartsTech's orders</p>
    <div *ngFor="let qoute of orders; let ind = index" class="ui-g-12 p-0 ro-partstech-order flex-column" [hidden]="!hasOrders">
      <div class="partstech-order">
        <div class="partstech-order-header width-100p flex-between-center p-2">
          <img src="assets/img/partstech-logo-1.svg" class="partstech-logo pl-2" alt="PartsTech" />

          <div class="partstech-order-header-right flex-end-center">
            <div class="flex-column">
              <span class="mr-3 font-13"> Last synced: {{ qoute.partsTechLastSynced }} </span>
            </div>
            <div [ngClass]="{ 'disabled-estimate-btn': estimate?.isArchived }">
              <button
                class="btn font-600"
                [ngClass]="{ 'btn-secondary': qoute.isOrderPlaced, 'btn-primary': !qoute.isOrderPlaced }"
                [disabled]="isOrderPlacing || qoute.isOrderPlaced || estimate?.isArchived"
                (click)="handlePlaceOrderSync('PartsTech')"
              >
                <span [ngClass]="{ 'pr-2': isOrderPlacing && !qoute.isOrderPlaced }">
                  {{ qoute?.isOrderDelivered ? 'Delivered' : qoute.isOrderPlaced ? 'Order Submitted' : 'Place order' }}
                </span>
                <i class="fal fa-spinner rotate" *ngIf="isOrderPlacing && !qoute.isOrderPlaced"></i>
              </button>
            </div>
          </div>
        </div>

        <div class="partstech-order-theader width-100p flex-start-center p-2 mb-1">
          <p class="m-0 font-600 name pl-2">Item name</p>
          <p class="m-0 font-600 description pl-2">Description</p>
          <p class="m-0 font-600 number pl-2">Item#</p>
          <p class="m-0 font-600 cost">Cost</p>
          <p class="m-0 font-600 list-price">
            List Price
            <i class="fal fa-info-circle text-dark pl-1" tooltipPosition="top" pTooltip="List price is the vendor's recommended price"></i>
          </p>
          <p class="m-0 font-600 core">Core</p>
          <p class="m-0 font-600 qty">Qty</p>
          <p class="m-0 font-600 amount">Amount</p>
          <p class="m-0 font-600 service pl-2">Service</p>
          <p class="m-0 font-600 status text-right">Status</p>
          <p class="m-0 font-600 action pr-2"></p>
        </div>

        <div class="partstech-order-body width-100p flex-column p-2" *ngFor="let order of qoute.orders; let orderIndex = index">
          <p class="supplier-name m-0 font-gray-85 font-600 ml-2 mr-2 mb-1 pb-1">
            {{ order?.supplier?.name }}
          </p>

          <div class="part-row flex-start-center" *ngFor="let part of order?.parts; let partIndex = index">
            <div class="m-0 name pl-2 flex-between-center not-allowed" tooltipPosition="top" [pTooltip]="part?.partName">
              <img *ngIf="part?.imageUrl" class="thumbnail pr-2" [src]="part?.imageUrl" [alt]="part?.partName" />
              <p class="part-name text-truncate m-0" [ngClass]="{ 'no-service-attached': !getPartService(part.orderItemId, part.partId), 'not-allowd': estimate?.isArchived }">
                <span [ngClass]="{ error: !getPartService(part.orderItemId, part.partId) }">{{ part?.partName }}</span>
              </p>
            </div>

            <p class="m-0 description text-truncate pl-2 not-allowed" [ngClass]="{ 'not-allowed': estimate?.isArchived }" tooltipPosition="top" [pTooltip]="part?.partName">
              <span>{{ part?.partName }}</span>
            </p>

            <p class="m-0 number text-truncate pl-2 not-allowed" [ngClass]="{ 'not-allowed': estimate?.isArchived }">
              <span [pTooltip]="part?.partNumber">{{ part?.partNumber }}</span>
            </p>

            <p class="m-0 cost not-allowed" tooltipPosition="top" [pTooltip]="part?.costUpdateMessage" [ngClass]="{ 'font-red': part?.isCostUpdated }">
              {{ part?.price?.cost | currency : usd }}
            </p>

            <p class="m-0 list-price not-allowed" tooltipPosition="top" [pTooltip]="part?.priceUpdateMessage" [ngClass]="{ 'font-red': part?.isPriceUpdated }">
              {{ part?.price?.list | currency : usd }}
            </p>

            <p class="m-0 core not-allowed" [ngClass]="{ 'not-allowed': estimate?.isArchived }">
              {{ part?.price?.core | currency : usd }}
            </p>

            <p class="m-0 qty not-allowed" [ngClass]="{ 'not-allowed': estimate?.isArchived }">
              {{ part?.quantity | number : '1.2-2' }}
            </p>

            <p class="m-0 amount not-allowed" [ngClass]="{ 'not-allowed': estimate?.isArchived }">
              {{ part?.amount | currency : usd }}
            </p>

            <div class="m-0 service partstech-service-dropdown pl-2" [ngClass]="{ 'no-service-attached': !getPartService(part.orderItemId, part.partId) }">
              <div [ngClass]="{ 'disabled-estimate-field': estimate?.isArchived }">
                <app-dropdown
                  placeholder="Select service"
                  styleClassText="pr-3"
                  field="title"
                  theme="light"
                  scrollHeight="300px"
                  itemWidth="250px"
                  editFieldLabel="Unassign service"
                  [hasEditableField]="!!getPartService(part.orderItemId, part.partId)"
                  [disabled]="true"
                  [value]="getPartService(part.orderItemId, part.partId)"
                  [fontSize]="12"
                  [truncateString]="true"
                  [isDropdownIconVisible]="true"
                  [options]="services"
                  [isStaticEditButton]="true"
                >
                </app-dropdown>
              </div>
            </div>

            <p
              class="m-0 status pr-2 text-truncate not-allowed"
              tooltipPosition="top"
              [pTooltip]="orders[ind]?.isOrderDelivered ? 'Delivered' : qoute.isOrderPlaced && !part.deliveryStatus ? 'Ordered' : part?.status"
            >
              <span>{{ orders[ind]?.isOrderDelivered ? 'Delivered' : qoute.isOrderPlaced && !part.deliveryStatus ? 'Ordered' : part?.status }}</span>
            </p>
          </div>
        </div>
      </div>
    </div>
    <!-- PartsTech suppliers Footer for total amount values -->
    <div *ngIf="totalSuppliers?.length && isPartsTechEnabled" class="ui-g-12 p-0 partstech-supplier">
      <!-- Supplier table header -->
      <div class="partstech-supplier-header flex-column width-100p pt-2 pb-2">
        <!-- <div class="flex-start-center pb-2">
          <img src="assets/img/partstech-logo-1.svg" class="partstech-logo pl-2" alt="Nexpart">
        </div> -->

        <div class="flex-start-center">
          <p class="m-0 font-600 name pl-2">Supplier</p>

          <p class="m-0 font-600 qty flex-center-center">
            <span class="width-90p">Quantity</span>
          </p>

          <p class="m-0 font-600 cost flex-center-center">
            <span class="width-100px">Items&nbsp;Total&nbsp;Cost</span>
          </p>

          <p class="m-0 font-600 ship-cost flex-center-center">
            <span class="width-90p">Shipping</span>
          </p>

          <p class="m-0 font-600 order-total pr-2 flex-center-center">
            <span class="width-90p">Order Total</span>
          </p>
        </div>
      </div>

      <!-- Supplier table body -->
      <div class="partstech-supplier-body width-100p flex-start-center pt-2 pb-2" *ngFor="let supplier of totalSuppliers">
        <p class="m-0 name pl-2">
          {{ supplier?.name }}
        </p>

        <p class="m-0 qty flex-center-center">
          <span class="width-90p">{{ supplier?.quantity | number : '1.2-2' }}</span>
        </p>

        <p class="m-0 cost flex-center-center">
          <span class="width-100px">{{ supplier?.cost | currency : usd }}</span>
        </p>

        <p class="m-0 ship-cost flex-center-center">
          <span class="width-90p"> {{ supplier?.shippingPrice | currency : usd }}</span>
        </p>

        <p class="m-0 order-total pr-2 flex-center-center">
          <span class="width-90p">{{ supplier?.orderTotal | currency : usd }}</span>
        </p>
      </div>

      <!-- Supplier table footer -->
      <div class="partstech-supplier-footer width-100p flex-start-center pt-2 pb-2">
        <p class="m-0 font-600 name pl-2">Total</p>

        <p class="m-0 font-600 qty flex-center-center">
          <span class="width-90p">{{ orderTotal?.quantity | number : '1.2-2' }}</span>
        </p>

        <p class="m-0 font-600 cost flex-center-center">
          <span class="width-100px">{{ orderTotal?.cost | currency : usd }}</span>
        </p>

        <p class="m-0 font-600 ship-cost flex-center-center">
          <span class="width-90p">{{ orderTotal?.shippingPrice | currency : usd }}</span>
        </p>

        <p class="m-0 font-600 order-total pr-2 flex-center-center">
          <span class="width-90p">{{ orderTotal?.orderTotal | currency : usd }}</span>
        </p>
      </div>
    </div>
    <!-----------END------------------------PartsTech Quotes Section-------------------------END---------------------->

    <!-----------START------------------------Manual Parts Quotes Section-----------------------START-------------------->
    <p *ngIf="_orders?.manualOrder?.length && isManualPartOrderingEnabled" class="mb-2 pb-1 font-bold font-16 font-secondary-900 part-ordering-section-heading">Manual orders</p>
    <div *ngFor="let qoute of _orders.manualOrder" class="ui-g-12 p-0 ro-partstech-order flex-column" [hidden]="!isManualPartOrderingEnabled">
      <div class="partstech-order">
        <div class="partstech-order-header width-100p flex-between-center p-2">
          <img src="assets/img/manual-ordering-logo.svg" class="manualparts-logo pl-2" alt="PartsTech" />

          <div class="partstech-order-header-right flex-end-center">
            <div class="flex-column flex-center-between gray-35">
              <span class="mr-3 font-13" *ngIf="qoute.orderedAt"> Last synced: {{ qoute.orderedAt }} </span>
            </div>
            <!-- Place order -->
            <div [ngClass]="{ 'disabled-estimate-btn': estimate?.isArchived }">
              <button
                class="btn font-600"
                [ngClass]="{ 'btn-secondary': qoute.isOrderPlaced, 'btn-primary': !qoute.isOrderPlaced }"
                [disabled]="
                  (isPlacingOrder?.manualOrder && qoute[qoute?.qouteId]) || isModifyingOrder?.manualOrder || isOrderPlacing || qoute?.qoute?.orderStatus === 'received' || estimate?.isArchived
                "
                (click)="handleDeliverManualOrder(qoute?.qouteId, qoute?.qoute?.orderStatus === 'ordered' ? 'received' : 'ordered', qoute)"
              >
                <span [ngClass]="{ 'pr-2': isPlacingOrder?.manualOrder && !qoute.isOrderPlaced && qoute[qoute?.qouteId] }">
                  {{ qoute?.qoute?.orderStatus === 'ordered' ? 'Mark delivered' : qoute?.qoute?.orderStatus == 'draft' ? 'Mark ordered' : 'Delivered' }}
                </span>
                <i class="fal fa-spinner rotate" *ngIf="isPlacingOrder?.manualOrder && !qoute.isOrderPlaced && qoute[qoute?.qouteId]"></i>
              </button>
            </div>
          </div>
        </div>

        <div class="partstech-order-theader width-100p flex-start-center py-2 mb-1">
          <p class="m-0 font-600 name pl-2">Item name</p>
          <p class="m-0 font-600 description pl-2">Description</p>
          <p class="m-0 font-600 number pl-2">Item#</p>
          <p class="m-0 font-600 cost">Cost</p>
          <p class="m-0 font-600 list-price">
            Price
            <i class="fal fa-info-circle text-dark pl-1" tooltipPosition="top" pTooltip="List price is the vendor's recommended price"></i>
          </p>
          <p class="m-0 font-600 core">Core</p>
          <p class="m-0 font-600 qty">Qty</p>
          <p class="m-0 font-600 amount">Amount</p>
          <p class="m-0 font-600 service-manual pl-2">Service</p>
          <p class="m-0 font-600 status pr-2">Status</p>
        </div>

        <div *ngFor="let order of qoute?.qoute?.orders; let orderIndex = index" class="partstech-order-body width-100p flex-column">
          <p *ngIf="!orderIndex" class="supplier-name manual-order-header m-0 font-gray-85 font-600 mb-1 pb-1">
            {{ qoute?.qoute?.supplier?.name || 'Untitled' }}
          </p>

          <div *ngFor="let part of order?.items; let partIndex = index" class="part-row manual-order flex-start-center">
            <div class="m-0 name pl-2 flex-between-center not-allowed" tooltipPosition="top" [pTooltip]="part?.title">
              <p class="part-name text-truncate m-0">
                <span>{{ part?.title }}</span>
              </p>
            </div>

            <p class="m-0 description text-truncate pl-2 not-allowed" [ngClass]="{ 'not-allowed': estimate?.isArchived }" tooltipPosition="top" [pTooltip]="part?.title">
              <span>{{ part?.description }}</span>
            </p>

            <p class="m-0 number text-truncate pl-2 not-allowed" [ngClass]="{ 'not-allowed': estimate?.isArchived }">
              <span [pTooltip]="part?.code">{{ part?.code }}</span>
            </p>

            <p class="m-0 cost not-allowed" tooltipPosition="top" [pTooltip]="part?.costUpdateMessage" [ngClass]="{ 'font-red': part?.isCostUpdated }">
              {{ part?.cost | currency : usd }}
            </p>

            <p class="m-0 list-price not-allowed" tooltipPosition="top" [pTooltip]="part?.priceUpdateMessage" [ngClass]="{ 'font-red': part?.isPriceUpdated }">
              {{ part?.price | currency : usd }}
            </p>

            <p class="m-0 core not-allowed" [ngClass]="{ 'not-allowed': estimate?.isArchived }">
              {{ part?.coreCost | currency : usd }}
            </p>

            <p class="m-0 qty not-allowed" [ngClass]="{ 'not-allowed': estimate?.isArchived }">
              {{ part?.quantity | number : '1.2-2' }}
            </p>

            <p class="m-0 amount not-allowed" [ngClass]="{ 'not-allowed': estimate?.isArchived }">
              {{ part?.amount | currency : usd }}
            </p>

            <div class="m-0 service-manual partstech-service-dropdown pl-2 text-truncate pr-2" tooltipPosition="top" [pTooltip]="order?.title">
              {{ order?.title }}
            </div>

            <p
              class="m-0 status manual-part-status text-truncate"
              [ngClass]="qoute?.qoute?.orderStatus == 'ordered' ? 'ordered' : qoute?.qoute?.orderStatus == 'received' ? 'delivered' : 'unordered'"
              tooltipPosition="top"
              [pTooltip]="
                qoute?.qoute?.orderStatus == 'ordered'
                  ? 'Ordered'
                  : qoute?.qoute?.orderStatus == 'received'
                  ? 'Delivered'
                  : qoute?.qoute?.orderStatus == 'draft'
                  ? 'Unordered'
                  : qoute?.qoute?.orderStatus
              "
            >
              <span>{{
                qoute?.qoute?.orderStatus == 'ordered'
                  ? 'ordered'
                  : qoute?.qoute?.orderStatus == 'received'
                  ? 'Delivered'
                  : qoute?.qoute?.orderStatus == 'draft'
                  ? 'Unordered'
                  : qoute?.qoute?.orderStatus
              }}</span>
            </p>
          </div>
        </div>
      </div>
    </div>
    <!-----------END------------------------Manual Parts Quotes Section-----------------------END-------------------->
  </div>
</div>
